<template>
  <v-chip-group show-arrows>
    
    <v-slide-x-transition group leave-absolute>
      <v-chip v-if="showEmpty && !allSelections.length" key="empty" outlined label>
        {{$t('Qlik.Selections.empty')}}
      </v-chip>
      <v-chip 
        v-for="selection in allSelections" :key="selection.field" 
        close 
        @click:close="selection.remove"
        :color="selection.color || 'primary'"
        label
        dark
        style="opacity: 1!important; cursor: auto; color: #FFFFFF!important; transform-origin: none!important;"
        class="chip-override"
        :ripple="false"
      >
        <v-icon left>{{selection.icon}}</v-icon>
        <span class="mr-1">{{selection.label}}</span>
        <span v-if="selection.selectedCount <= 1">
          {{selection.value.substring(0, 15)}}
        </span>
        <span v-else>
          ({{selection.selectedCount}} {{$t('Global.Common.xofy')}} {{selection.totalCount}})
        </span>
      </v-chip>
    </v-slide-x-transition>
  </v-chip-group>
</template>

<script>
import { hiddenSelectionFields } from '@/config/qlik'
import { createSelectionObject } from '@portal/qlik'

export default {
  name: 'QlikSelections',
  props: {
    apps: {type: Array, required: true},
    showEmpty: {type: Boolean, required: false}
  },
  data: () => ({
    isOpen: true,
    managers: []
  }),
  computed: {
    allSelections() {
      return this.managers
        .reduce((all, manager) => [...all, ...manager.selections], [])
        .filter(selection => !hiddenSelectionFields[selection.field])
    }
  },
  methods: {
    removeAll () {
      const removing = []
      for (const selection of this.allSelections) {
        removing.push(selection.remove())
      }
      return Promise.all(removing)
    },
    async init () {
      if (this.$qlik) {
        for (const app of this.apps) {
          const selectionsObject = await createSelectionObject(this.$qlik[app.qAppId].enigmaDoc)
          this.managers.push({
            qObject: selectionsObject,
            app,
            selections: []
          })

          this.updateSelections(selectionsObject, app)
          selectionsObject.on('changed', async () => {
            this.updateSelections(selectionsObject, app)
          })
        }
      }
    },
    async updateSelections (selectionsObject, app) {
      const index = this.managers.findIndex(manager => manager.app.id === app.id)
      try {
        const layout = await selectionsObject.getLayout()
        this.managers[index].selections = layout.qSelectionObject.qSelections
          .map(select => ({
            field: select.qField,
            label: select.qReadableName || select.qField,
            value: select.qSelected,
            color: app.color,
            icon: app.icon,
            selectedCount: select.qSelectedCount,
            totalCount: select.qTotal,
            remove: async () => await (await this.$qlik[app.qAppId].enigmaDoc.getField(select.qField)).clear()
          }))
      } catch (error) {
        this.managers[index].selections = []
      }
    },
  },
  created () {
    this.init()
  },
  async beforeDestroy () {
    // await this.removeAll()
    for (const manager of this.managers) {
      this.$qlik[manager.app.qAppId].enigmaDoc.destroySessionObject(manager.qObject.id)
    }
    
  }
}
</script>

<style>
.v-chip:focus, .v-chip:before {
  opacity: 0!important;
}
</style>